import { gql } from "@apollo/client";

const ADD_PRODUCT = gql `
mutation AddProductBusiness($sbuId: ID!, $productId: ID!, $code: String!, $urlSlug: String!, $useQtyPricing: Boolean, $transferRule: String, $isAvailable: Boolean, $altTitle: String, $altDescription: String, $altBasePrice: Decimal, $accountRequired: Boolean, $description: String, $basePrice: Decimal, $categoryId: ID!, $title: String!, $isProductOwner: Boolean = false, $note: String = "", $username: String = "") {
  addProductBusiness(
    productBusiness: {productId: $productId, sbuId: $sbuId, code: $code, urlSlug: $urlSlug, useQtyPricing: $useQtyPricing, transferRule: $transferRule, isAvailable: $isAvailable, altTitle: $altTitle, altDescription: $altDescription, altBasePrice: $altBasePrice, accountRequired: $accountRequired}
    product: {categoryId: $categoryId, title: $title, description: $description, basePrice: $basePrice}
    productManager: {isProductOwner: $isProductOwner, note: $note, username: $username}
  ) {
    success
    errors
    productBusiness {
      id
      code
      altTitle
      altDescription
      altBasePrice
      accountRequired
      isAvailable
      transferRule
      urlSlug
      useQtyPricing
      
      product {
        uuid
        title
        description
        basePrice
        createdAt
        updatedAt
        category {
          id
          name
          physicalProduct
          description
        }
      }
      prices {
        id
        isActive
        maxQuantity
        minQuantity
        price
        datePriceModified
        datePriceAdded
      }
    }
 productManager{
  uuid
  manager{
    username
    firstName
    lastName
    uict
  }
  isProductOwner
  note
}
  }
}
`
const UPDATE_PRODUCT = gql`
mutation UpdateProductBusiness($id:ID!, $sbuId: ID!, $productId: ID!, $code: String!, $urlSlug: String!, $useQtyPricing: Boolean, $transferRule: String, $isAvailable: Boolean, $altTitle: String, $altDescription: String, $altBasePrice: Decimal, $accountRequired: Boolean, $description: String, $basePrice: Decimal, $categoryId: ID!, $title: String!, $isProductOwner: Boolean = false, $note: String = "", $username: String = "") {
  updateProductBusiness(
    productBusiness: {id:$id, productId: $productId, sbuId: $sbuId, code: $code, urlSlug: $urlSlug, useQtyPricing: $useQtyPricing, transferRule: $transferRule, isAvailable: $isAvailable, altTitle: $altTitle, altDescription: $altDescription, altBasePrice: $altBasePrice, accountRequired: $accountRequired}
    product: {categoryId: $categoryId, title: $title, description: $description, basePrice: $basePrice}
    productManager: {isProductOwner: $isProductOwner, note: $note, username: $username}
  ) {
    success
    errors
    productBusiness {
      id
      code
      altTitle
      altDescription
      altBasePrice
      accountRequired
      isAvailable
      transferRule
      urlSlug
      useQtyPricing
      
      product {
        uuid
        title
        description
        basePrice
        createdAt
        updatedAt
        category {
          id
          name
          physicalProduct
          description
        }
      }
      prices {
        id
        isActive
        maxQuantity
        minQuantity
        price
        datePriceModified
        datePriceAdded
      }
    }
 productManager{
  uuid
  manager{
    username
    firstName
    lastName
    uict
  }
  isProductOwner
  note
}
  }
}
`

const BATCH_FIELDS = `
  uuid
  status
  totalAmount
  currency
  periodStart
  periodEnd
  createdAt
  updatedAt
  approvedAt
  initiatedAt
  completedAt
  stripeTransferId
  notes
  sbuUser {
    id
    user {
      username
      firstName
      lastName
    }
  }
  approvedBy {
    id
    user {
      username
    }
  }
`;

const ASSEMBLE_PAYOUT_BATCH = gql`
  mutation AssemblePayoutBatch($periodStart: Date, $periodEnd: Date) {
    assemblePayoutBatch(input: { periodStart: $periodStart, periodEnd: $periodEnd }) {
      success
      errors
    }
  }
`;

const APPROVE_PAYOUT_BATCH = gql`
  mutation ApprovePayoutBatch($batchId: ID!) {
    approvePayoutBatch(input: { batchId: $batchId }) {
      success
      errors
      payoutBatch {
        ${BATCH_FIELDS}
      }
    }
  }
`;

const INITIATE_PAYOUT_BATCH_TRANSFER = gql`
  mutation InitiatePayoutBatchTransfer($batchId: ID!) {
    initiatePayoutBatchTransfer(input: { batchId: $batchId }) {
      success
      errors
      payoutBatch {
        ${BATCH_FIELDS}
      }
    }
  }
`;

export { ADD_PRODUCT, UPDATE_PRODUCT, ASSEMBLE_PAYOUT_BATCH, APPROVE_PAYOUT_BATCH, INITIATE_PAYOUT_BATCH_TRANSFER }